import React from 'react';
import FuelerIcon from './components/FuelerIcon';
import styled from 'styled-components';

const Container = styled.div`
    padding-left: 20px;
    padding-left: 20px;
    color: #fff;
    max-height: 100px;
    width: 50vw;
    padding: 20px 0 0 20px;
`

const StatusContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`;

const MessageContainer = styled.div`
    margin: 20px 0 0 0;
    width: 100%;
`

const StatusLabel = styled.span`
    padding-right: 5px;
`


const OnlineStatus = ({ online }) => {

    const statusIcon = online ? 'online' : 'offline'
    const statusColor = online ? '#42B72A' : 'red'
    const statusSize = online ? '12px' : '16px'
    const status = online ? 'Online' : 'Offline';
    const offlineMessage = 'You may submit logs while offline and your data will be uploaded when you regain network connectivity.'

    return (
        <Container>
            <StatusContainer>
                <StatusLabel>Status: </StatusLabel>
                <StatusLabel>{status}</StatusLabel>
                <FuelerIcon icon={statusIcon} size={statusSize} fill={statusColor} />        
            </StatusContainer>
            { !online && (<MessageContainer>{offlineMessage}</MessageContainer>) }
        </Container>
    );
};

export default OnlineStatus;


// WEBPACK FOOTER //
// ./src/OnlineStatus.js